module.exports = __webpack_public_path__ + "img/failure.4c8d4550.png";